<template>
  <app-industry-profile-template class="app-industry-profile-template-hospitality"
          title="<span class='color-black'>Disrupted</span> by sharing platforms and OTA’s<span class='color-black'>?</span>"
          industryName="Hospitality"
          casesRouteName="HospitalityCases"
          :brands="brands">

    <p class="no-margin">
      <strong>Are you being disrupted by sharing platforms and OTA’s?</strong><br><br>

      In an industry disrupted by sharing platforms and having margins eaten in to by the powerful OTAs,
      your customer loyalty program has never been more important.<br><br>

      <strong>Adding extra firepower to your current program</strong><br><br>

      We have developed a solution, that will increase customer loyalty significantly by building a merchant ecosystem 
      with your brands right in the middle. This creates daily relevance for all your members, the active and 
      especially the “not so active”, increases direct bookings, reduces OTA reliance, and adds incremental F&B revenue.
      <br><br>

      <strong>Learn how</strong><br><br>

    <img v-on:keyup.enter="videoThumbnailOnClick"
           v-on:click.prevent="videoThumbnailOnClick"
           src="@/assets/images/video-thumbnails/hospitality.jpg" alt="Hospitality video image" tabindex="0">
      <br><br>

      <strong>We can help you implement and operate this part of your program</strong><br><br>

      From our work in the sector, we understand what is needed from a customer experience perspective and we have the
      enabling global technology to make any program a game changer - or if you are just starting – give your program a
      smashing start.
    </p>

    <div id="hospitality-video" class="wistia_embed popover=true wistia_async_o52rof4wkd" style="visibility: hidden; height: 0;">&nbsp;</div>
  </app-industry-profile-template>
</template>

<script>
  import AppIndustryProfileTemplate from '@/components/layout/templates/view/AppViewTemplateIndustryProfile';

  /* Models */
  import Brands from '@/models/brands';

  export default {
      name: 'HospitalityProfile',

      components: {
        AppIndustryProfileTemplate
      },

      data: function() {
          return {
            brands: {
              title: 'Featured cases',
              items: [],
            },
          }
      },

      methods: {
        videoThumbnailOnClick() {
          window.wistiaInit = function(W) {
            let video = W.api("hospitality-video");

            video.play();

            video.bind("popovershow", function() {
              //console.log("The popover for ", video.hashedId(), " is visible!");
            });

            video.bind("popoverhide", function() {
              //console.log("The popover for ", video.hashedId(), " is hidden!");
            });
          };
        },

        getBrands() {
          this.brands.items = new Brands().getIndustries('Hospitality');
        }
      },

      created() {
        this.getBrands();
      },

      beforeDestroy() {
        document.getElementById('hospitality-video_popover_container').remove();
      }
  }
</script>

<style lang="scss">
  .app-industry-profile-template-hospitality {
    min-height: calc(100vh - 100px);

    @media (min-width: $lgBreakpoint) {
      .banners {
        background-image: url("../../../assets/images/industries/banners/hospitality.jpg");
      }
    }

    img {
      max-width: 100%;
      display: block;
      cursor: pointer;

      &:hover, &:focus {
        opacity: 0.7;
      }
    }
  }
</style>
